var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_8992",
    "data-name": "Group 8992",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.699,
    height: 23,
    viewBox: "0 0 19.699 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2004",
    "data-name": "Rectangle 2004",
    width: 19.7,
    height: 23,
    fill: "#d80027"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8991",
    "data-name": "Group 8991",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4178",
    "data-name": "Path 4178",
    d: "M14.851,80.333a1.357,1.357,0,0,0-1.314-1.373l-6.414-.011a1.387,1.387,0,0,0-1.345,1.366v2.24H1.5V77.788L.169,77.78a.152.152,0,0,1-.162-.1A.154.154,0,0,1,.1,77.5l5.085-2.954a4.737,4.737,0,0,0,9.336,0L19.6,77.5a.161.161,0,0,1,.1.15.15.15,0,0,1-.168.132H18.2l0,6.618H14.848Z",
    transform: "translate(0 -69.773)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4179",
    "data-name": "Path 4179",
    d: "M11.04,262.263H2.655a.233.233,0,0,1-.217-.245v-6.391h8.84v6.391a.234.234,0,0,1-.238.246m-4.421-6.207a2.558,2.558,0,1,0,2.787,2.306,2.554,2.554,0,0,0-2.787-2.306",
    transform: "translate(-2.282 -239.263)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4180",
    "data-name": "Path 4180",
    d: "M156.753,247.462a.6.6,0,0,1-.594.645l-3.731.006.006-7.6h4.319Z",
    transform: "translate(-142.671 -225.112)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4181",
    "data-name": "Path 4181",
    d: "M103.966,158.183l-.392-.011v-.936a.382.382,0,1,0-.763,0v.948h-.6l.014-2.285a.612.612,0,0,1,.634-.55h6.312a.637.637,0,0,1,.581.647v4.039h-4.3l-.021-.5a1.442,1.442,0,0,0-1.459-1.353",
    transform: "translate(-95.665 -145.403)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4182",
    "data-name": "Path 4182",
    d: "M95.33.03a3.97,3.97,0,1,1-3.459,4.457A3.966,3.966,0,0,1,95.33.03M96.2,6.86l.19-.472a2.65,2.65,0,0,0,.71-.294l.48.2.544-.542-.2-.481a2.55,2.55,0,0,0,.306-.73l.469-.184-.008-.791-.468-.181a2.47,2.47,0,0,0-.3-.712l.2-.475-.545-.547a3.308,3.308,0,0,0-.472.206,2.721,2.721,0,0,0-.736-.313l-.189-.478-.782.009-.174.47a2.714,2.714,0,0,0-.732.312l-.471-.208-.548.549.2.475a2.471,2.471,0,0,0-.3.713l-.482.2.006.773.48.2a2.227,2.227,0,0,0,.294.712l-.2.48.544.543.48-.2a2.766,2.766,0,0,0,.707.3l.2.474Z",
    transform: "translate(-85.959 0)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4183",
    "data-name": "Path 4183",
    d: "M267.495,247.314c-.036.342-.229.708-.56.712l-2.026.023v-7.6l2.026.021c.332,0,.519.375.559.691Zm-1.406-5.51a.475.475,0,1,0,.576.347.472.472,0,0,0-.576-.347m.364,3.383a.373.373,0,0,0,.368-.411.381.381,0,0,0-.4-.353H266a.388.388,0,0,0-.415.4.393.393,0,0,0,.41.368Zm0,1.258a.369.369,0,0,0,.369-.377.365.365,0,0,0-.347-.377l-.531,0a.378.378,0,0,0,0,.756Z",
    transform: "translate(-247.952 -225.058)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4184",
    "data-name": "Path 4184",
    d: "M11.362,213.569l-8.834,0,.023-1.462a.653.653,0,0,1,.594-.6h7.64a.778.778,0,0,1,.563.6Zm-3.58-.643a.393.393,0,0,0,.346-.406.379.379,0,0,0-.37-.359H6.085a.38.38,0,0,0,0,.759Zm1.32-.746a.377.377,0,0,0-.232.511.384.384,0,0,0,.472.211.38.38,0,0,0-.24-.722m.91,0a.377.377,0,0,0-.232.511.384.384,0,0,0,.473.211.38.38,0,0,0-.24-.722",
    transform: "translate(-2.366 -197.973)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4185",
    "data-name": "Path 4185",
    d: "M232.8,261.942c0,.267.279.376.524.309l0,1.667h-1.341V258.65h1.341v1.659a.5.5,0,0,0-.391.067.414.414,0,0,0-.148.311Z",
    transform: "translate(-217.132 -242.093)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4186",
    "data-name": "Path 4186",
    d: "M56.2,51.706l-1.776,1.019V51.269a.146.146,0,0,1,.144-.135l1.594.009a1.024,1.024,0,0,1,.038.563",
    transform: "translate(-50.941 -47.861)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4187",
    "data-name": "Path 4187",
    d: "M231.5,353.267h-1.452l.116-.41H231.5a1.149,1.149,0,0,1,0,.409",
    transform: "translate(-215.326 -330.27)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4188",
    "data-name": "Path 4188",
    d: "M233.332,240.846l-1.333,0v-.4h1.325a1.37,1.37,0,0,1,.009.4",
    transform: "translate(-217.148 -225.055)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4189",
    "data-name": "Path 4189",
    d: "M44.956,274.1a1.794,1.794,0,1,1-1.487,2.061,1.787,1.787,0,0,1,1.487-2.061",
    transform: "translate(-40.665 -256.531)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4190",
    "data-name": "Path 4190",
    d: "M133.657,40.663a1.369,1.369,0,1,1-1.158,1.583,1.362,1.362,0,0,1,1.158-1.583",
    transform: "translate(-124 -38.046)",
    fill: "#d80027"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.3fe66a2c702d7c635724e3985d441c4b.svg";
export { ForwardRef as ReactComponent };